import { useEffect } from 'react'
import { useQueryState, parseAsString } from 'nuqs'

import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import ChannelAnalyticListing from '@/modules/dashboard/components/ChannelAnalytic/components/ChannelAnalyticListing'
import useQueryGetChannelAnalytic from '@/modules/dashboard/api/hooks/useQueryGetChannelAnalytic'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useDateFilter } from '@/common/hooks/useDateFilter'

function ChannelAnalyticPage() {
	const { currentPage, pageSize, selectedQuery, searchQuery } =
		useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault('all'),
	)

	// On first load, if no dateRange has been set (or it's 'all'), clear dates
	useEffect(() => {
		if (dateRange === 'all') {
			setDateFilter({ startDate: null, endDate: null })
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		isActiveChannel: selectedQuery,
		name: searchQuery || undefined,
	}

	const { data, isLoading } = useQueryGetChannelAnalytic(payload)

	return (
		<PageContainer>
			<ChannelAnalyticListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedChannelAnalyticPage = withUserPermission(ChannelAnalyticPage, {
	permissionType: PermissionType.Read,
	permissionKey: [
		PermissionKeys.MANAGE_CHANNEL_ANALYTICS,
		PermissionKeys.MANAGE_MARKETING,
	],
})

export default GuardedChannelAnalyticPage
